module.exports = __webpack_public_path__ + "img/vodacom-generic-background-desktop.5ac5d2f7.png";